import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    upgrade: {
        id: 'settings.identity.level.upgrade',
        defaultMessage: 'Upgrade',
    },
    submit: {
        id: 'settings.identity.level.submit',
        defaultMessage: 'Submit',
    },
    contactSupport: {
        id: 'settings.identity.level.contact_support',
        defaultMessage: 'Contact support',
    },
    contactSupportLink: {
        id: 'settings.identity.level.contact_support.link',
        defaultMessage: '#',
    },
    current: {
        id: 'settings.identity.level.current',
        defaultMessage: 'You are here',
    },
    notVerified: {
        id: 'settings.identity.level.notVerified',
        defaultMessage: 'Not verified',
    },
    limit: {
        id: 'settings.identity.level.limit',
        defaultMessage: 'Crypto withdrawal limit',
    },
    buyWithCard: {
        id: 'settings.identity.level.buyWithCard',
        defaultMessage: 'Buy Crypto with card',
    },
    wireTransferFiat: {
        id: 'settings.identity.level.wireTransferFiat',
        defaultMessage: 'Wire transfer fiat',
    },
    level1Title: {
        id: 'settings.identity.level.1.title',
        defaultMessage: 'Title 1',
    },
    level1Limit: {
        id: 'settings.identity.level.1.limit',
        defaultMessage: 'Limit 1',
    },
    level1BuyWithCard: {
        id: 'settings.identity.level.1.buyWithCard',
        defaultMessage: 'BuyWithCard 1',
    },
    level1WireTransferFiat: {
        id: 'settings.identity.level.1.wireTransferFiat',
        defaultMessage: 'WireTransferFiat 1',
    },
    pendingStatus: {
        id: 'settings.identity.level.status.pending',
        defaultMessage: 'Pending',
    },
    rejectedStatus: {
        id: 'settings.identity.level.status.rejected',
        defaultMessage: 'Rejected',
    },
    infoRequestedStatus: {
        id: 'settings.identity.level.status.info_requested',
        defaultMessage: 'Info requested',
    },
})
